import React from "react";

function CloseBg({ width = 20, height = 20, fill = "#C75A00" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00033 0.666504C4.39199 0.666504 0.666992 4.3915 0.666992 8.99984C0.666992 13.6082 4.39199 17.3332 9.00033 17.3332C13.6087 17.3332 17.3337 13.6082 17.3337 8.99984C17.3337 4.3915 13.6087 0.666504 9.00033 0.666504ZM13.167 11.9915L11.992 13.1665L9.00033 10.1748L6.00866 13.1665L4.83366 11.9915L7.82533 8.99984L4.83366 6.00817L6.00866 4.83317L9.00033 7.82484L11.992 4.83317L13.167 6.00817L10.1753 8.99984L13.167 11.9915Z"
        fill={fill}
      />
    </svg>
  );
}

export default CloseBg;
